import { PlanWarnings, PricingPlans } from '@constants/pricing';

import { getPlanName } from './common';
import dayjs from 'dayjs';

export const getPlanValidityTitle = (
  type: PlanWarnings,
  remainingUploadCount: number,
  projectUploadLimitByPlan: number,
  currentUserPlan: PricingPlans,
  isTrialUser: boolean,
  currentUserPlanEndDate: string
) => {
  switch (type) {
    case PlanWarnings.UPLOAD_LIMIT:
      return `${remainingUploadCount} out of ${projectUploadLimitByPlan} remaining uploads left under current ${getPlanName(
        currentUserPlan as PricingPlans,
        isTrialUser as boolean
      )}`;
    case PlanWarnings.UPGRADE_TRIAL:
    case PlanWarnings.RENEW_PLAN:
      return `Your current ${getPlanName(
        currentUserPlan,
        isTrialUser
      )} plan is about to expire on ${dayjs(currentUserPlanEndDate)?.format(
        'Do MMM YYYY'
      )}`;
    case PlanWarnings.EXPIRED_PLAN:
      return `Your current Pro Trial plan has expired`;
    case PlanWarnings.LABEL_CLICK:
      return 'Your file is too big for current Free plan :(';
    default:
      return 'Upgrade to Pro';
  }
};

export const getPlanValiditySubTitle = (
  type: PlanWarnings,
  has_used_trial?: boolean,
  message?: string
) => {
  switch (type) {
    case PlanWarnings.UPLOAD_LIMIT:
    case PlanWarnings.UPGRADE_TRIAL:
    case PlanWarnings.RENEW_PLAN:
      return 'Upgrade to the Pro plan to enjoy advanced features with unlimited file uploads.';
    case PlanWarnings.EXPIRED_PLAN:
      return 'Upgrade to the Pro plan to enjoy advanced features with unlimited file uploads.';
    case PlanWarnings.LABEL_CLICK:
      if (has_used_trial)
        return (
          message +
          ' are uploaded as you are on a Free plan. No worries! Upload files with unlimited rows & columns with the Pro plan.\nSimply click below and enjoy advanced features with unlimited file uploads.'
        );
      else
        return (
          message +
          ` are uploaded as you are on a Free plan. No worries! Upload files with unlimited rows & columns with a free 3-day Pro Trial — no credit or debit card needed.\nSimply click below to start the trial and enjoy advanced features with unlimited file uploads.`
        );
    default:
      return '';
  }
};

export const updateBannerSessionAction = () => {
  window.sessionStorage.setItem('plan-banner-action', 'false');
};

export const getBannerSessionValidity = () => {
  const sessionValue = window.sessionStorage.getItem(
    'plan-banner-action'
  ) as string;

  if (sessionValue === 'false') return false;
  else return true;
};

export const getModalName = (type: PlanWarnings) => {
  switch (type) {
    case PlanWarnings.UPLOAD_LIMIT:
      return `Upload Limit exceeded`;
    case PlanWarnings.UPGRADE_TRIAL:
    case PlanWarnings.RENEW_PLAN:
      return `Plan about to expire`;
    case PlanWarnings.EXPIRED_PLAN:
      return `Plan expired`;

    default:
      return '';
  }
};
